import { AI_COLUMN_ID } from "../../../constants";
import IntegrationsAiTableDropdownActionsCell from "./DropdownActionsCell";
import IntegrationsAiTableModelCell from "./ModelCell";
import IntegrationsAiTableNameCell from "./NameCell";
import IntegrationsAiTableProviderCell from "./ProviderCell";
import IntegrationsAiTableSpaceCell from "./SpaceCell";

export const INTEGRATIONS_AI_TABLE_CELLS = {
  [AI_COLUMN_ID.PROVIDER]: IntegrationsAiTableProviderCell,
  [AI_COLUMN_ID.NAME]: IntegrationsAiTableNameCell,
  [AI_COLUMN_ID.MODEL]: IntegrationsAiTableModelCell,
  [AI_COLUMN_ID.SPACE]: IntegrationsAiTableSpaceCell,
  [AI_COLUMN_ID.DROPDOWN]: IntegrationsAiTableDropdownActionsCell,
};
